/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Dateofbirth2Inputs */

const en__field_dateofbirth2 = /** @type {(inputs: _Field_Dateofbirth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of Birth`)
};

const de__field_dateofbirth2 = /** @type {(inputs: _Field_Dateofbirth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

/**
* | output |
* | --- |
* | "Date of Birth" |
*
* @param {_Field_Dateofbirth2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_dateofbirth2 = /** @type {((inputs?: _Field_Dateofbirth2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Dateofbirth2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_dateofbirth2(inputs)
	return de__field_dateofbirth2(inputs)
});
export { _field_dateofbirth2 as "_field_dateOfBirth" }